import { AssetType } from '@/types/assets'
import { LayoutBox, LayoutBoxField, LayoutBoxType } from '@/types/layouts'

const BOX = {
  transition: {
    id: 'transition',
    name: 'transition',
    active: true,
    height: 1080,
    width: 1920,
    field: LayoutBoxField.TRANSITION,
    left: 0,
    top: 0,
    invisible: false,
    type: LayoutBoxType.BOX,
    types: [AssetType.Stinger],
    zindex: 300
  } as LayoutBox,
  background: {
    id: 'background',
    name: 'background',
    field: LayoutBoxField.BACK,
    active: true,
    height: 1080,
    width: 1920,
    left: 0,
    top: 0,
    invisible: false,
    type: LayoutBoxType.BOX,
    types: [AssetType.Graphic],
    zindex: 1
  } as LayoutBox,
  slates: {
    id: 'slates',
    name: 'slates',
    active: true,
    height: 1080,
    width: 1920,
    field: LayoutBoxField.FRONT,
    left: 0,
    top: 0,
    invisible: false,
    type: LayoutBoxType.BOX,
    types: [AssetType.Graphic],
    zindex: 200
  } as LayoutBox
}

export default BOX
